<template>
  <transition name="fade">
    <div class="cf">
      <div class="flex fl w-100">
        <h1 class="page-header mv2 f4 f3-l ">Welcome, {{ displayName }}</h1>
      </div>
      <div class="flex-l flex-column fl w-100 featured-game-container" :style="{ backgroundImage: 'url(' + image + ')' }">
        <div class="flex-l flex-wrap w-100 featured-game-hero ph3-l">
          <div class="fl w-100 w-70-l">
            <transition name="enterFromRight" appear>
              <div class="feature-game-content tl-l">
                <p class="f6 fw3">Featured Game</p>
                <h1 class="tl f3 f1-l white-80 mt3 w-70 featured-game-title">BLOCKFIGHT</h1>
                <p class="pb3-l">BlockFight is a creature vs creature fighting game with provably fair battle outcomes determined by the blockchain.</p>
                <a class="f5 f4-l no-underline grow dib v-mid ba ph3 ph4-ns pv2 pv2-ns mb3 mr3 cta-button" :href="gameUrl" target="_blank" rel="noopener noreferrer">Play</a>
              </div>
            </transition>
          </div>
          <div class="flex flex-column fl w-100 w-30-l mt3-l">
            <transition name="EnterFromAbove" appear>
              <div class="flex flex-column content-stretch ml3-l mb3 pv1 bg-component-dashboard achievement-container">
                <pc-achievements-recent-all />
              </div>
            </transition>
            <transition name="appearsecond" appear :duration="2000">
              <pc-announcement-container/>
            </transition>
          </div>
        </div>
        <div class="w-50-l mb5 ml3-l frequently-played-container">
          <h2 class="f4 f3-l">Games</h2>
          <div id="our-games-content">
            <pc-freq-play-games/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  data () {
    return {
      image: require('@/assets/BF_dashboard_fade.png'), // background image
      gameUrl: process.env.VUE_APP_URL_BLOCKFIGHT
    }
  },
  computed: {
    ...mapGetters({
      displayName: 'user/displayName',
      playerId: 'user/playerId',
      authToken: 'auth/authToken'
    })
  }
}
</script>

<style lang="scss" scoped>
.featured-game-container {
  background-repeat: no-repeat;
  /*background-position: center;*/
  border-top: 1px solid gray;
}
.featured-game-hero {
  height: 600px;
}
.frequently-played-container {
  margin-top: -130px;
}
.bg-component-dashboard {
  background-image: linear-gradient(rgba(37, 36, 44, 1), rgba(52, 51, 63, 0.5));
  border-radius: 2px;
  border: 1px solid rgb(36, 36, 41);
  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, .24), 0 3px 3px rgba(0, 0, 0, .24);
}
.featured-game-title {
  text-shadow: 3px 3px 10px black;
  -webkit-webkit-text-shadow: 3px 3px 10px black;
  -moz-webkit-text-shadow: 3px 3px 10px black;
  -ms-webkit-text-shadow: 3px 3px 10px black;
  -o-webkit-text-shadow: 3px 3px 10px black;
  webkit-text-shadow: 3px 3px 10px black;
}

@media screen and (max-width: 1280px) {
  .frequently-played-container {
    margin-top: 0;
  }
}
</style>
